import { Fragment, VFC } from 'react'
import { MYPAGE, TOP } from 'src/utils/routes'
import styled from 'styled-components'

export type BreadCrumbProps = {
  parentPaths?: {
    label: string
    path: string
  }[]
  currentPath: string
  color?: string
}
const DEFAULT_PARENT = [
  {
    label: 'Home',
    path: TOP,
  },
  {
    label: 'マイページ',
    path: MYPAGE,
  },
]
export const BreadCrumb: VFC<BreadCrumbProps> = ({
  currentPath,
  parentPaths = DEFAULT_PARENT,
}) => {
  return (
    <BreadCrumbDiv>
      {parentPaths.map(({ label, path }) => (
        <Fragment key={path}>
          {path ? <a href={path}>{label}</a> : label}
          <Seperator>{'›'}</Seperator>
        </Fragment>
      ))}
      {currentPath}
    </BreadCrumbDiv>
  )
}

const Seperator = styled.span`
  margin: 0 4px;
`
const BreadCrumbDiv = styled.div`
  a {
    :hover {
      text-decoration: underline;
    }
  }
  @media screen and (max-width: 540px) {
    display: none;
  }
`
